import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CoachingSuggestion,
  DecisionResponse
} from 'src/app/services/copilot/copilot.types';

@Component({
  selector: 'app-copilot-decision-summary',
  templateUrl: './copilot-decision-summary.component.html',
  styleUrls: ['./copilot-decision-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopilotDecisionSummaryComponent {
  @Input() decision: DecisionResponse | null | undefined;
  /** Coaching cards stay under "Why Ask AI thinks this"; approach is always visible. */
  @Input() coachingSuggestions: CoachingSuggestion[] | null | undefined;
  @Input() debugMode = false;

  showDetails = false;

  /** Collapsed “why” details only — suggested approach renders above the fold. */
  get hasDetails(): boolean {
    const d = this.decision;
    if (!d) {
      return false;
    }
    return Boolean(
      d.observation ||
        d.confidence?.explanation ||
        d.explanations?.length ||
        d.signals?.length ||
        this.coachingSuggestions?.length ||
        (this.debugMode && d.evidence?.length),
    );
  }

  confidenceLabel(level: string): string {
    switch (level) {
      case 'high':
        return 'High confidence';
      case 'medium':
        return 'Moderate confidence';
      case 'low':
        return 'Low confidence';
      default:
        return 'Insufficient evidence';
    }
  }
}
